import { render, staticRenderFns } from "./time.vue?vue&type=template&id=2bdb51a4&scoped=true&"
import script from "./time.vue?vue&type=script&lang=js&"
export * from "./time.vue?vue&type=script&lang=js&"
import style0 from "./time.vue?vue&type=style&index=0&id=2bdb51a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdb51a4",
  null
  
)

component.options.__file = "time.vue"
export default component.exports